export const getRedirectPathname = (appMode, pathname, module) => {
  if (appMode === 'tester') return '/tester';
  else if (pathname.match('/reward-screen')) return '/app-selection';
  else return `/${module}/reward-screen`;
};

export const getModuleFromUrl = () => {
  return window.location.pathname.split('/')[1];
};
